var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 359,
    viewBox: "0 0 700 359",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M376.45 1.06688C452.27 45.7852 478.219 63.6724 534.578 67.7377C579.664 70.99 667.296 35.6219 699.192 20.9868M699.192 87.2512C606.748 120.993 551.201 133.189 518.359 127.904C485.518 122.619 423.078 75.4618 368.341 44.159C324.552 19.1168 257.652 -0.288224 236.569 1.06688M1 14.4823C78.0363 20.1738 185.887 53.5092 182.643 84.812C179.4 116.115 22.0836 123.432 1 170.59M1 207.177C65.0617 176.688 149.802 142.133 234.947 142.133C320.092 142.133 498.492 206.364 564.176 192.949C616.723 182.217 680.271 134.951 699.192 117.741M124.258 1.06686C198.456 15.2954 221.567 30.7435 275.492 74.6487C318.633 109.773 378.343 134.273 402.805 142.133M1 266.531C120.609 221.813 216.702 196.201 284.007 205.551C351.312 214.902 420.645 286.857 463.218 358M699.192 182.786C653.376 199.047 508.223 219.78 474.57 247.83C440.918 275.881 514.305 344.178 530.523 358M699.192 228.724C612.425 247.83 565.798 245.798 557.283 272.629C550.471 294.094 596.612 344.991 614.047 358M699.192 281.572C610.373 248.856 590.692 297.667 674.054 358M1 308.81C87.7672 279.946 170.885 246.204 220.756 266.531C260.653 282.792 269.411 339.435 266.572 358M318.065 358C290.089 299.46 286.034 274.255 299.009 266.531C311.983 258.807 382.532 325.884 398.345 358M28.1654 358C54.5199 339.706 124.663 308.81 156.694 308.81C182.319 308.81 225.216 338.487 228.054 358M1 56.7614C52.4927 64.4855 92.2272 72.2096 97.4981 84.812C102.769 97.4144 8.29817 107.171 1 110.83M477.409 1.06688C525.791 19.7912 551.955 21.8998 595.801 1.06688",
    stroke: "white",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19811_91611",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 75,
    width: 324,
    height: 201
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.551 274.669L189.309 84.9827L441.413 75.3848L508.987 99.9792L510.722 261.294L192.551 274.669Z",
    fill: "#345BC1",
    stroke: "#345BC1",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19811_91611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.551 274.669L189.309 84.9827L441.413 75.3848L508.987 99.9792L510.722 261.294L192.551 274.669Z",
    fill: "#83B2EE",
    stroke: "#83B2EE",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.874 142.942L496.536 136.457M202.684 200.091L496.536 195.228M338.869 89.8464L344.139 257.241M412.636 87.4146L424.39 253.998M261.86 91.873L266.724 260.483",
    stroke: "#307FE2",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.911,
    y: 73.634,
    width: 19.455,
    height: 71.7405,
    transform: "rotate(16.9635 188.911 73.634)",
    fill: "#307FE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.248 84.7515L200.658 94.2511L203.668 264.131L498.968 252.152L497.327 104.843",
    stroke: "#307FE2",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.949 141.726L233.893 129.162M233.893 129.162L244.026 141.726M233.893 129.162C232.263 160.485 232.18 178.137 233.893 209.819M233.893 209.819L241.189 199.281M233.893 209.819L222.949 199.281M252.537 105.654L241.189 116.192M241.189 116.192L251.321 125.919M241.189 116.192C319.5 111.538 363.618 109.803 443.034 109.707M443.034 109.707L436.144 119.434M443.034 109.707L432.496 102.006M443.034 138.889C452.597 139.488 456.41 143.753 466.137 140.684C480.728 135.241 481.438 142.461 490.456 143.753M446.277 149.833C457.486 150.056 463.218 150.593 473.027 151.859M384.669 211.035L376.158 217.925M376.158 217.925L384.669 227.653M376.158 217.925C403.129 218.711 410.877 217.9 438.576 215.899M438.576 215.899L429.254 225.626M438.576 215.899L429.254 207.792M265.913 249.134C277.93 245.506 286.2 244.645 297.527 243.865M263.481 238.596C275.235 228.869 280.099 238.191 289.421 230.49C296.878 224.329 304.417 228.734 307.254 231.706",
    stroke: "#DDEFFF",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.413 75.2553L509.1 99.9794L483.971 111.328L441.413 75.2553Z",
    fill: "#307FE2",
    stroke: "#307FE2",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.401 185.87C259.062 181.438 259.283 177.31 260.144 173.34C262.152 164.063 267.388 155.542 274.957 148.561C284.271 139.971 296.548 133.623 310.751 129.436C320.823 126.464 331.253 124.64 341.318 124.123C358.839 122.49 376.314 124.213 391.668 129.448C408.523 135.194 421.302 144.581 427.557 157.849C431.391 165.981 432.331 174.972 431.606 187.227C431.599 187.551 431.599 187.853 431.601 188.419L431.602 188.548C431.614 191.656 431.462 193.159 430.633 195.069C429.667 197.299 427.916 199.034 425.668 200.16C421.888 202.05 417.277 202.532 411.775 202.11C407.803 201.805 403.975 200.912 398.737 199.259C398.096 199.058 398.096 199.058 397.44 198.853C391.663 197.05 388.879 195.85 385.97 193.373C382.876 190.739 381.332 187.454 380.938 183.217C380.885 182.642 380.84 182.113 380.766 181.21L380.733 180.821C380.435 177.195 380.233 175.475 379.808 173.501C378.292 166.472 374.387 159.84 368.865 154.832C362.002 148.609 352.185 145.144 343.017 145.593C327.93 147.057 314.205 158.592 310.969 172.858C310.284 175.882 310.16 179.186 310.518 182.957C310.569 183.494 310.637 184.046 310.752 184.881C310.802 185.241 310.802 185.241 310.853 185.609C311.243 188.433 311.359 189.971 311.186 191.793C310.78 196.063 308.43 199.522 304.583 202.384C302.339 204.053 299.78 205.416 296.334 206.932C295.516 207.292 294.698 207.64 293.215 208.268C288.323 210.352 283.744 211.673 279.165 212.18C272.481 212.92 268.147 212.428 264.786 209.071C262.712 207.012 262.062 205.012 261.476 201.012C261.439 200.756 261.439 200.756 261.402 200.507C261.342 200.112 261.338 200.076 261.287 199.764C260.339 195.861 259.876 192.11 259.401 185.87Z",
    fill: "#DDEFFF",
    stroke: "#DDEFFF",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.621 62.8007L199.466 71.2435L166.101 213.543L140.091 206.304L173.621 62.8007ZM152.083 208.353C154.966 208.747 157.623 206.73 158.017 203.846C158.411 200.963 156.394 198.306 153.511 197.912C150.627 197.518 147.97 199.536 147.576 202.419C147.182 205.302 149.2 207.959 152.083 208.353Z",
    fill: "#AFA5EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.466 71.2435L199.791 71.3197C199.831 71.151 199.735 70.9801 199.57 70.9263L199.466 71.2435ZM173.621 62.8007L173.725 62.4835C173.636 62.4545 173.539 62.464 173.457 62.5099C173.376 62.5558 173.317 62.6337 173.296 62.7248L173.621 62.8007ZM166.101 213.543L166.011 213.864C166.099 213.888 166.193 213.876 166.271 213.83C166.349 213.783 166.405 213.707 166.426 213.619L166.101 213.543ZM140.091 206.304L139.766 206.229C139.725 206.403 139.829 206.578 140.002 206.626L140.091 206.304ZM199.57 70.9263L173.725 62.4835L173.518 63.1179L199.363 71.5607L199.57 70.9263ZM166.426 213.619L199.791 71.3197L199.141 71.1673L165.776 213.466L166.426 213.619ZM140.002 206.626L166.011 213.864L166.19 213.221L140.18 205.983L140.002 206.626ZM173.296 62.7248L139.766 206.229L140.416 206.38L173.946 62.8766L173.296 62.7248ZM157.687 203.801C157.317 206.502 154.829 208.392 152.128 208.022L152.038 208.684C155.104 209.103 157.929 206.957 158.348 203.892L157.687 203.801ZM153.465 198.243C156.166 198.612 158.056 201.101 157.687 203.801L158.348 203.892C158.767 200.826 156.622 198.001 153.556 197.581L153.465 198.243ZM147.907 202.464C148.276 199.763 150.765 197.873 153.465 198.243L153.556 197.581C150.49 197.162 147.665 199.308 147.246 202.374L147.907 202.464ZM152.128 208.022C149.428 207.653 147.538 205.165 147.907 202.464L147.246 202.374C146.826 205.439 148.972 208.264 152.038 208.684L152.128 208.022Z",
    fill: "#AFA5EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.435 204.45L169.097 206.589",
    stroke: "#6254B6",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165.232 192.97L171.894 195.108",
    stroke: "#6254B6",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168.029 181.489L174.691 183.627",
    stroke: "#6254B6",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M170.826 170.008L177.488 172.146",
    stroke: "#6254B6",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M173.623 158.527L180.285 160.665",
    stroke: "#6254B6",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M176.42 147.046L183.082 149.184",
    stroke: "#6254B6",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.217 135.564L185.879 137.703",
    stroke: "#6254B6",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M182.014 124.083L188.676 126.222",
    stroke: "#6254B6",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M184.811 112.603L191.473 114.741",
    stroke: "#6254B6",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M187.608 101.122L194.27 103.26",
    stroke: "#6254B6",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M190.405 89.6409L197.067 91.779",
    stroke: "#6254B6",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M193.203 78.1597L199.865 80.2978",
    stroke: "#6254B6",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_19811_91611",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 497,
    y: 173,
    width: 41,
    height: 128
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M520.827 193.935L537.067 173.341L537.452 203.213L516.975 298.187C516.737 299.291 515.633 299.98 514.537 299.708L506.818 297.797C503.685 297.022 501.145 294.735 500.045 291.701L498.305 286.899C498.192 286.589 498.174 286.253 498.253 285.933L520.827 193.935Z",
    fill: "#043ED6",
    stroke: "#043ED6",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_19811_91611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M520.827 193.935L537.067 173.341L537.452 203.213L516.54 300.204L496.536 292.931L520.827 193.935Z",
    fill: "#FCBB26",
    stroke: "#FCBB26",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.37 191.986L539.904 159.561L546.795 197.255C545.714 199.281 542.823 203.335 539.904 203.335C536.986 203.335 533.014 200.362 531.393 198.876H523.287C521.017 198.876 516.396 194.283 514.37 191.986Z",
    fill: "#FFD8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.316 274.264L531.798 198.471M531.798 198.471C534.929 202.677 537.052 203.031 541.12 202.119M531.798 198.471C525 199.959 521.246 200.389 515.991 191.175",
    stroke: "#D69702",
    strokeWidth: 0.667398,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.941 277.507L498.562 270.616L524.908 279.533L523.692 287.234L496.941 277.507Z",
    fill: "#A8ACBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.861 275.885L531.393 289.261L526.934 314.796L490.861 294.125V275.885Z",
    fill: "#FF854C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.499,
    cy: 166.451,
    r: 16.2125,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.536 277.912L522.476 286.423M498.968 271.021L523.287 278.722",
    stroke: "#616987",
    strokeWidth: 0.667398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSupport);
export default __webpack_public_path__ + "static/media/no_support.dc709cfb1c609172164c11d996a9eaef.svg";
export { ForwardRef as ReactComponent };